module.exports = function() {
  return new Worker(__webpack_public_path__ + "84bed271dbd00538f738.worker.js");
};